/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMediaContentSectionFragment} from '@amblique/contentful/app/contentful/fragments/media-content-section/base-media-content-section.fragment';
import {IconFragment} from '@amblique/contentful/app/contentful/fragments/icon/icon.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {VideoFragment} from '@amblique/contentful/app/contentful/fragments/video/video.fragment';

export const FullMediaContentSectionFragment = gql`
  ${BaseMediaContentSectionFragment}
  ${IconFragment}
  ${ImageFragment}
  ${VideoFragment}

  fragment FullMediaContentSectionFragment on MediaContentSection {
    ...BaseMediaContentSectionFragment

    media {
      ... on Icon {
        ...IconFragment
      }
      ... on Image {
        ...ImageFragment
      }
      ... on Video {
        ...VideoFragment
      }
    }
  }
`;
